import type { FeedbackPriority, FeedbackStatus, FeedbackType } from '@crm/shared'

export const TYPE_LABELS: Record<FeedbackType, string> = {
  BUG: '🐛 Баг',
  IDEA: '💡 Идея',
}

export const PRIORITY_LABELS: Record<FeedbackPriority, string> = {
  CRITICAL: 'Критично',
  NORMAL: 'Обычный',
  LOW: 'Низкий',
}

export const STATUS_LABELS: Record<FeedbackStatus, string> = {
  NEW: 'Новая',
  IN_PROGRESS: 'В работе',
  FIXED: 'Исправлено',
  REJECTED: 'Отклонено',
}

export const STATUS_COLORS: Record<FeedbackStatus, string> = {
  NEW: 'bg-blue-100 text-blue-700',
  IN_PROGRESS: 'bg-amber-100 text-amber-700',
  FIXED: 'bg-green-100 text-green-700',
  REJECTED: 'bg-gray-200 text-gray-600',
}
